import request from "@/utils/server.js";

// 获取关键词回复列表
export function getKeywordReplyListAPI(data) {
  return request({
    url: "/keyword/list",
    method: "get",
    params: data,
  });
}

// 修改关键词回复状态
export function updateKeywordReplyStatusAPI(data) {
  return request({
    url: "/keyword/update",
    method: "put",
    data,
  });
}

// 创建关键词回复
export function createKeywordReplyAPI(data) {
  return request({
    url: "/keyword/add",
    method: "post",
    data,
  });
}

// 删除关键词回复
export function deleteKeywordReplyAPI(data) {
  return request({
    url: `/keyword/delete`,
    method: "delete",
    data,
  });
}
